import { render, staticRenderFns } from "./select-validated.vue?vue&type=template&id=23bfde74&"
import script from "./select-validated.vue?vue&type=script&lang=js&"
export * from "./select-validated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports